import { render, staticRenderFns } from "./DetailMJumpModal.vue?vue&type=template&id=67ab8b85&scoped=true&lang=pug&"
import script from "./DetailMJumpModal.vue?vue&type=script&lang=js&"
export * from "./DetailMJumpModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailMJumpModal.vue?vue&type=style&index=0&id=67ab8b85&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ab8b85",
  null
  
)

export default component.exports